import { render, staticRenderFns } from "./VenusList.vue?vue&type=template&id=067307cb&scoped=true"
import script from "./VenusList.vue?vue&type=script&lang=js"
export * from "./VenusList.vue?vue&type=script&lang=js"
import style0 from "./VenusList.vue?vue&type=style&index=0&id=067307cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067307cb",
  null
  
)

export default component.exports